var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_setup.TransactionsTable,_vm._g(_vm._b({on:{"transaction-cancel":_setup.cancelTransaction,"withdraw-succeded":_setup.updateList}},'TransactionsTable',{ ..._setup.managedListing.bindings, ..._vm.$attrs },false),{ ..._setup.managedListing.listeners, ..._vm.$listeners }))
}
var staticRenderFns = []

export { render, staticRenderFns }